// extracted by mini-css-extract-plugin
export default {"countCondition":"House_countCondition__Pq2QO","download":"House_download__y22CF"};